
import vClickOutside from 'v-click-outside';

export default {
  name: "FilterDropdownWrapperMobile",

  directives: {
    clickOutside: vClickOutside.directive,
  },

  props: {
    filterDisplayValue: {
      type: String,
      default: ''
    },
    // displayValue: {
    //   type: String,
    //   default: '',
    // },
    filterTitle: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      dropdownActive: false,
      // wrapperWidth: 0,
    }
  },
  mounted() {
    const type = this.mode.split(' ');
    const storeMode = this.$store.getters['modal/showDisplayMobileFilter'].mode;

    // this.wrapperWidth = this.$refs.filterContainer.querySelector('.filter-wrapper').offsetWidth;
    this.$nextTick(() => {
      if (type[0] == storeMode) {
          this.dropdownActive = true;
      }
    })
  },
  methods: {
    toggleDropdown() {
      // console.debug('dropdown wrapper click');
      // this.dropdownActive = !this.dropdownActive;
      if ( this.dropdownActive ) {
        this.closeDropdown();
      } else {
        this.dropdownActive = true;
      }
    },
    closeDropdown() {
      if ( this.dropdownActive ) {
        this.$emit('on-close', false);
        this.dropdownActive = false;
      }
    }
  }
}
